export const translations = {
  dateTimePicker: {
    chooseDate: {
      'en-150': 'Choose date',
      'sk-SK': 'Vybrať dátum'
    },
    chooseTime: {
      'en-150': 'Choose time',
      'sk-SK': 'Vybrať čas'
    },
    noTime: {
      'en-150': 'Do not enter time',
      'sk-SK': 'Nezadávať čas'
    },
    today: {
      'en-150': 'Go to Today',
      'sk-SK': 'Prejsť na dnešok'
    }
  }
}
